import type { MouseEventHandler } from 'react';
import { cn } from '@/helpers/utils';

type BurgerButtonProps = {
    onClick: MouseEventHandler<HTMLButtonElement>;
    activeNav: boolean;
    label: string;
    controls?: string;
};

export default function BurgerButton({ onClick, activeNav, label, controls }: BurgerButtonProps) {
    return (
        <button
            type="button"
            className="inline-flex text-0 w-8 h-7 xl:hidden p-1"
            onClick={onClick}
            aria-label={label}
            aria-expanded={activeNav}
            aria-controls={controls}
        >
            <div className="relative h-full w-full" aria-hidden="true">
                <span
                    className={cn(
                        'absolute w-full h-[3px] bg-black top-1/2 left-0 transition-transform duration-200 transform will-change-transform',
                        activeNav ? 'rotate-45 -translate-y-[1px]' : '-translate-y-2.5'
                    )}
                />
                <span
                    className={cn(
                        'absolute w-full h-[3px] bg-black top-1/2 left-0 transition-opacity duration-200 transform will-change-transform -translate-y-1/2',
                        activeNav && 'opacity-0'
                    )}
                />
                <span
                    className={cn(
                        'absolute w-full h-[3px] bg-black top-1/2 left-0 transition-transform duration-200 transform will-change-transform',
                        activeNav ? '-rotate-45 -translate-y-[1px]' : 'translate-y-[7px]'
                    )}
                />
            </div>
        </button>
    );
}
